// AffiliateProductDetails.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient from '../api/apiClient';

const AffiliateProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
    const navigate = useNavigate();
  

  useEffect(() => {
    apiClient.get(`/admin/aff/${id}`).then(res => {
      setProduct(res.data);
    });
  }, [id]);

  console.log("product is : ",product)

  if (!product) return <div className="container my-5">Loading...</div>;

  return (
    <>

    {product.active ? (
      <div className="container" style={{paddingTop: '120px'}}>
        <div style={{ margin: '20px 0', fontSize: '14px', color: '#555' }}>
  <strong>Disclosure:</strong> This post contains affiliate links; 
  if you make a purchase through them, I may earn a small commission—at no extra cost to you.
</div>
      <div className="row g-4">
        <div className="col-md-6">
          <img
            src={product.imageUrls?.[0] || '/placeholder.jpg'}
            className="img-fluid border p-3 rounded"
            alt={product.title}
            style={{ maxHeight: '450px', objectFit: 'contain' }}
          />
        </div>
        <div className="col-md-6">
          <h4>{product.title}</h4>
          <p className="text-muted">{product.brand}</p>
          <h5 className="mt-auto">
                  <span className="badge bg-danger mb-2 mr-2">
                    {Math.round(
                      ((product.originalPrice - product.price) /
                        product.originalPrice) *
                      100
                    )}
                    % OFF
                  </span>

                  <span className="card-text fw-bold price">
                    <span className="rupee">₹</span>{new Intl.NumberFormat('en-IN').format(product.price)}
                  </span>
                </h5>
                <p className="text-muted price">M.R.P. : 
                  <span className="rupee">₹</span>
<span className='text-decoration-line-through'>{new Intl.NumberFormat('en-IN').format(product.originalPrice)}</span>
                </p>
          
          <p><strong>Category:</strong> {product.category}</p>

          <a
            href={product.affiliateLink}
            className="btn btn-warning btn-lg mt-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy Now on Amazon
          </a>
        </div>
      </div>

      <hr className="my-5" />

      <div>
  <h4>Product Review</h4>
  {product.description ? (
    product.description.split('|||').map((paragraph, idx) => {
      let title, content;
      if (paragraph.includes('::')) {
        [title, content] = paragraph.split('::').map(s => s.trim());
      } else {
        content = paragraph.trim(); // no title, just content
      }
      return (
        <div key={idx} className="mb-4">
          {title && <h5 className="fw-bold">{title}</h5>}
          {content && <p className="lead">{content}</p>}
          {product.imageUrls?.[idx+1] && (
            <div>
              <img
                src={product.imageUrls[idx+1]}
                alt={`Review visual ${idx + 1}`}
                className="img-fluid my-3 rounded border"
                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
              />
            </div>
          )}
        </div>
      );
    })
  ) : (
    <p className="lead">No review available.</p>
  )}
</div>



    </div>
    ) : navigate('/affiliate')
  }
    
    </>
  );
};

export default AffiliateProductDetails;
